import styled from 'styled-components';
import BaseStopStationIcon from '#/shared/components/BaseStopStationIcon';
import SvgMap from '#/shared/components/GeneratedIcons/trimet/Map';
import { ClearButton } from '#/shared/components/Styled';

export const StopIconColumn = styled.div`
  display: flex;
  flex: 0 0 20px;
`;

export const StopIcon = styled(BaseStopStationIcon).attrs(props => ({
  width: 20,
  height: 20,
  fill: props.theme.primaryFontColor,
  isSolid: true,
}))`
  padding: 0 10px 2px;
`;

export const StopsList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  padding: 0 12px;
  font-weight: 600;
`;

export const StopItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const SelectedStopItem = styled(StopItem)`
  background-color: ${props => props.theme.selectedStopColor};
`;

export const ArrivalText = styled.div`
  display: flex;
  flex: 1;
  text-align: end;
  align-self: start;
  cursor: default;
  color: ${props => props.theme.primaryFontColor};
`;

export const DropOffOnlyText = styled.div`
  display: flex;
  flex: 0 1 auto;
  background-color: ${props => props.theme.dangerColor};
  align-self: start;
  cursor: default;
  color: white;
  line-height: 1;
  padding: 2px 8px;
  margin: 0 5px;
  border-radius: ${props => props.theme.buttonRadius};
`;

export const ArrivalSpan = styled.span`
  flex: 1 1 auto;
  align-self: flex-end;
  width: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StopNameWrapper = styled.div.attrs(
  ({ vehiclePassedStop, theme }) => ({
    fillColor: vehiclePassedStop ? theme.inactiveColor : theme.primaryFontColor,
  })
)`
  display: flex;
  flex: 7;
  color: ${({ fillColor }) => fillColor};

  & ${StopIcon} {
    fill: ${({ fillColor }) => fillColor};
  }
`;

export const MapIcon = styled(SvgMap).attrs(props => ({
  width: 16,
  height: 16,
  fill: props.theme.secondaryColor,
}))`
  display: flex;
  opacity: ${props => props.theme.inactiveOpacity};
  @media (any-hover: hover) {
    &:hover {
      opacity: 1;
      background-color: transparent;
    }
  }
  &:focus,
  &:active {
    background-color: transparent;
  }
`;

export const MapButton = styled(ClearButton)`
  font: inherit;

  &:hover {
    // override inherited value
    background-color: unset;
  }
`;

export const NoStops = styled.div`
  font-weight: normal;
`;
